/* eslint-disable complexity */
import {
  BookWidgetAem,
  BookWidgetFields,
  TripTypeOptions
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { Tab } from '@com-delta-omnichannel/mach';
import { searchModalTabIds } from '../../constants/common.constants';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';
import { SavedTripList } from '../../models/core-apis/saved-search.interfaces';

export const prepareSearchModalTabs = (
  bookWidgetAem: BookWidgetAem | null,
  retrieveSearchDataList: RetrieveSearchData[] | null,
  savedSearchDataList: SavedTripList[] | [] | undefined,
  bookWidgetFields: BookWidgetFields
) => {
  const searchModalTabs: Tab[] = [
    {
      label: bookWidgetAem?.airportsField.searchModal.searchLabel || '',
      id: searchModalTabIds.SEARCH
    }
  ];

  if (
    retrieveSearchDataList?.length &&
    bookWidgetFields.tripTypesField.selectedTripType !==
      TripTypeOptions.MULTI_CITY
  ) {
    searchModalTabs.push({
      label: bookWidgetAem?.airportsField.searchModal.recentSearch || '',
      id: searchModalTabIds.RECENT_SEARCH
    });
  }

  if (
    savedSearchDataList?.length &&
    bookWidgetFields.tripTypesField.selectedTripType !==
      TripTypeOptions.MULTI_CITY
  ) {
    searchModalTabs.push({
      label: bookWidgetAem?.airportsField.searchModal.savedSearch || '',
      id: searchModalTabIds.SAVED_SEARCH
    });
  }

  return searchModalTabs;
};
